import { plainToClass } from 'class-transformer';
import { BiospecimenInventoryLookup } from './inventory-lookup';

const collectionWindowIdToIndex: { [key: number]: number } = {
    1: 0, // "0" => Day0
    2: 1, // "1 to 50" => Days1to50
    3: 2, // "51 to 75" => Days51to75
    4: 3, // "76 to 90" => Days76to90
    5: 4, // "91 to 168" => Days91to168
    6: 5, // "169 to 336" => Days169to336
    7: 6, // "Unscheduled Visit" => USV
    //0: 7  // "" => Unknown
};

export class Patient {
    SubjectId: string;
    StudyId: number;
    RecoverCohortId: number;
    AgeId: number;
    SexId: number;
    RaceId: number;
    EthnicityId: number;
    AppendixId: number;
    Samples: Sample[];

    initialize(): void {
        this.Samples = plainToClass(Sample, <Sample[]>this.Samples);
        this.Samples = this.Samples.map((sample: Sample) => {
            sample.Units = plainToClass(Unit, <Unit[]>sample.Units);
            return sample;
        });
    }
}

export class Sample {
    //BioBankRootId: string;
    ParentSampleId: string
    CollectionWindowId: number;
    SampleTypeId: number;
    Units: Unit[];

    constructor(sampleTypeId: number, collectionwindow: number) {
        this.SampleTypeId = sampleTypeId;
        this.CollectionWindowId = collectionwindow;
        this.Units = [];
    }
}

export class Unit {
    SampleId: string;
    UnitId: number;
    Status: number;
}

export class DropdownOption {
    Id: number;
    Value: string;

    constructor(public id: number,public type: string) {
        this.Id = id;
        this.Value = BiospecimenInventoryLookup.GetValueFromIdAndType(id, type);
    }
}
export class DisplayValues {
    ParticipantCount: number = 0;
    SampleCount: number = 0;
    UnitCount: number = 0;

    collection_windows: string[] = ["Day0", "Days1to50", "Days51to75", "Days76to90", "Days91to168", "Days169to336", "Unscheduled"]

    Participants_VisitDay0: number = 0;
    Participants_VisitDays1to50: number = 0;
    Participants_VisitDays51to75: number = 0;
    Participants_VisitDays76to90: number = 0;
    Participants_VisitDays91to168: number = 0;
    Participants_VisitDays169to336: number = 0;
    Participants_VisitUnscheduled: number = 0;
    //Participants_VisitUnknown: number = 0;

    Participants_Timepoint1: CountsBySample = new CountsBySample();
    Participants_Timepoint2: CountsBySample = new CountsBySample();
    Participants_Timepoint3: CountsBySample = new CountsBySample();
    Participants_Timepoint4: CountsBySample = new CountsBySample();
    Participants_Timepoint5: CountsBySample = new CountsBySample();
    Participants_Timepoint6: CountsBySample = new CountsBySample();
    //Participants_Timepoint7: CountsBySample = new CountsBySample();
    //Participants_Timepoint8: CountsBySample = new CountsBySample();

    Participants_BySampleType: number[] = new Array(BiospecimenInventoryLookup.SAMPLE_TYPES.length).fill(0);

    Samples_VisitDay0: CountsBySample = new CountsBySample();
    Samples_VisitDays1to50: CountsBySample = new CountsBySample();
    Samples_VisitDays51to75: CountsBySample = new CountsBySample();
    Samples_VisitDays76to90: CountsBySample = new CountsBySample();
    Samples_VisitDays91to168: CountsBySample = new CountsBySample();
    Samples_VisitDays169to336: CountsBySample = new CountsBySample();
    Samples_VisitUnscheduled: CountsBySample = new CountsBySample();
    Samples_VisitUnknown: CountsBySample = new CountsBySample();

    Units_VisitDay0: CountsBySample = new CountsBySample();
    Units_VisitDays1to50: CountsBySample = new CountsBySample();
    Units_VisitDays51to75: CountsBySample = new CountsBySample();
    Units_VisitDays76to90: CountsBySample = new CountsBySample();
    Units_VisitDays91to168: CountsBySample = new CountsBySample();
    Units_VisitDays169to336: CountsBySample = new CountsBySample();
    Units_VisitUnscheduled: CountsBySample = new CountsBySample();
    Units_VisitUnknown: CountsBySample = new CountsBySample();

    constructor() { }

    Reset() {
        this.ParticipantCount = 0; this.SampleCount = 0; this.UnitCount = 0;

        for (let i = 0; i < this.collection_windows.length; i++) {
            this[`Participants_Visit${this.collection_windows[i]}`] = 0;
            this[`Samples_Visit${this.collection_windows[i]}`].Reset();
            this[`Units_Visit${this.collection_windows[i]}`].Reset();
        }

        this.Participants_Timepoint1.Reset(); this.Participants_Timepoint2.Reset(); this.Participants_Timepoint3.Reset();
        this.Participants_Timepoint4.Reset(); this.Participants_Timepoint5.Reset(); this.Participants_Timepoint6.Reset();
        //this.Participants_Timepoint6.Reset();this.Participants_Timepoint7.Reset(); this.Participants_Timepoint8.Reset();

        this.Participants_BySampleType = new Array(BiospecimenInventoryLookup.SAMPLE_TYPES.length).fill(0);
    }

    Update(patients: Patient[], trials: string[], recovercohort: string[], specimenstatuses: string[], agegroup: string[], sexes: string[], races: string[], ethnicities: string[]) {
        this.Reset();
        let uniqueBiobankRootIds = new Set<string>();
        let plasmaEDTAIds = new Set<string>();
        let plasmaNaHepIds = new Set<string>();

        for (const patient of patients) {
            if (patient.Samples == undefined || patient.Samples.length == 0) continue;
            if (!trials.includes(patient.AppendixId + "") || !recovercohort.includes(patient.RecoverCohortId + "") || !sexes.includes(patient.SexId + "") || !races.includes(patient.RaceId + "") || !ethnicities.includes(patient.EthnicityId + "") || !agegroup.includes(patient.AgeId + "")) {
                continue;
            }

            let visitsByParticipant: boolean[] = new Array(this.collection_windows.length).fill(false);
            let sampleTypesByVisit_Patient: SampleByVisit = new SampleByVisit();
            let sampleTypesByVisit_Sample: SampleByVisit = new SampleByVisit();
            let sampleTypesByVisit_Unit: SampleByVisit = new SampleByVisit();

            let matchingSamples: number = 0;
            let matchingUnits: number = 0;

            for (const sample of patient.Samples) {
                const sampleTypeIndex = sample.SampleTypeId;
                let foundUnit: boolean = false;
                let visitIndex: number = collectionWindowIdToIndex[sample.CollectionWindowId];

                for (const unit of sample.Units) {
                    if (specimenstatuses.includes(unit.Status + "")) {
                        matchingUnits++;
                        sampleTypesByVisit_Unit.CountData[sampleTypeIndex][visitIndex] += 1;
                        foundUnit = true;
                    }
                }
                if (matchingUnits > 0 && foundUnit) {
                    matchingSamples++;
                    if (visitIndex >= 0) {
                        visitsByParticipant[visitIndex] = true;
                        sampleTypesByVisit_Patient.BooleanData[sampleTypeIndex][visitIndex] = true;
                        sampleTypesByVisit_Sample.CountData[sampleTypeIndex][visitIndex] += 1;
                    }
                    // Add to unique set here
                    //if (sample.BioBankRootId) {
                    //    uniqueBiobankRootIds.add(sample.BioBankRootId);
                    if (sample.ParentSampleId) {
                        uniqueBiobankRootIds.add(sample.ParentSampleId);
                    } else {
                        console.warn("Sample missing ParentSampleId", sample);
                    }
                    if (sample.SampleTypeId === 0 && sample.ParentSampleId) {
                        plasmaEDTAIds.add(sample.ParentSampleId);
                    }
                    if (sample.SampleTypeId === 1 && sample.ParentSampleId) {
                        plasmaNaHepIds.add(sample.ParentSampleId);
                    }
                }
            }

            if (matchingSamples > 0) {
                this.ParticipantCount += 1;
                //this.SampleCount += matchingSamples;
                this.UnitCount += matchingUnits;

                for (let i = 0; i < this.collection_windows.length; i++) {
                    if (visitsByParticipant[i]) { this[`Participants_Visit${this.collection_windows[i]}`]++; }
                }

                for (let sampleTypeId: number = 0; sampleTypeId < sampleTypesByVisit_Patient.BooleanData.length; ++sampleTypeId) {
                    let timepointCount: number = 0;
                    for (let i: number = 0; i < sampleTypesByVisit_Patient.BooleanData[sampleTypeId].length; ++i) {
                        if (sampleTypesByVisit_Patient.BooleanData[sampleTypeId][i] === true) {
                            timepointCount++;
                        }
                    }

                    if (timepointCount == 1) { this.Participants_Timepoint1.IncrementValueBySampleTypeIndex(sampleTypeId, 1); }
                    else if (timepointCount == 2) { this.Participants_Timepoint2.IncrementValueBySampleTypeIndex(sampleTypeId, 1); }
                    else if (timepointCount == 3) { this.Participants_Timepoint3.IncrementValueBySampleTypeIndex(sampleTypeId, 1); }
                    else if (timepointCount == 4) { this.Participants_Timepoint4.IncrementValueBySampleTypeIndex(sampleTypeId, 1); }
                    else if (timepointCount == 5) { this.Participants_Timepoint5.IncrementValueBySampleTypeIndex(sampleTypeId, 1); }
                    else if (timepointCount == 6) { this.Participants_Timepoint6.IncrementValueBySampleTypeIndex(sampleTypeId, 1); }
                    else if (timepointCount > 7) { console.log("Number participant timepoints for person out-of-range = " + timepointCount + " person = ", patient); }

                    for (let i = 0; i < this.collection_windows.length; i++) {
                        this[`Samples_Visit${this.collection_windows[i]}`].IncrementValueBySampleTypeIndex(sampleTypeId, sampleTypesByVisit_Sample.CountData[sampleTypeId][i]);
                        this[`Units_Visit${this.collection_windows[i]}`].IncrementValueBySampleTypeIndex(sampleTypeId, sampleTypesByVisit_Unit.CountData[sampleTypeId][i]);
                    }
                }
            }
        }
        // Only need this once, after the main loop
        this.SampleCount = uniqueBiobankRootIds.size;
        //console.log("Unique BioBankRootIds count:", uniqueBiobankRootIds.size);
        //console.log("Unique Plasma_EDTA count:", plasmaEDTAIds.size);
        //console.log("Unique Plasma_NaHep count:", plasmaNaHepIds.size);
    }
}

export class CountsBySample {
    constructor(
        public Plasma_EDTA: number = 0,
        public Plasma_NaHep: number = 0,
        public Serum_SST: number = 0,
        public Stool_OMR205: number = 0,
        public Stool_ME200: number = 0,
        public WholeBlood_EDTA: number = 0,
        public PAXgene_RNA: number = 0,
        public PBMC_CPT_NaCitrate: number = 0,
        public Plasma_CPT_NaHep: number = 0,
        public PBMC_NaHep: number = 0
    ) { }

    Reset() {
        this.Plasma_EDTA = 0;
        this.Plasma_NaHep = 0;
        this.Serum_SST = 0;
        this.Stool_OMR205 = 0;
        this.Stool_ME200 = 0;
        this.WholeBlood_EDTA = 0;
        this.PAXgene_RNA = 0;
        this.PBMC_CPT_NaCitrate = 0;
        this.Plasma_CPT_NaHep = 0;
        this.PBMC_NaHep = 0;
    }

    AddValues(values: number[]) {
        this.Plasma_EDTA += values[0];
        this.Plasma_NaHep += values[1];
        this.Serum_SST += values[2];
        this.Stool_OMR205 += values[3];
        this.Stool_ME200 += values[4];
        this.WholeBlood_EDTA += values[5];
        this.PAXgene_RNA += values[6];
        this.PBMC_CPT_NaCitrate += values[7];
        this.Plasma_CPT_NaHep += values[8];
        this.PBMC_NaHep += values[9];
    }

    IncrementValueBySampleTypeIndex(index: number, amount: number = 1) {
        switch (index) {
            case 0: this.Plasma_EDTA += amount; break;
            case 1: this.Plasma_NaHep += amount; break;
            case 2: this.Serum_SST += amount; break;
            case 3: this.Stool_OMR205 += amount; break;
            case 4: this.Stool_ME200 += amount; break;
            case 5: this.WholeBlood_EDTA += amount; break;
            case 6: this.PAXgene_RNA += amount; break;
            case 7: this.PBMC_CPT_NaCitrate += amount; break;
            case 8: this.Plasma_CPT_NaHep += amount; break;
            case 9: this.PBMC_NaHep += amount; break;
            default: console.warn("Invalid Sample Type Index:", index); break;
        }
    }

    GetDataArray(): number[] {
        return [
            this.Plasma_EDTA,
            this.Plasma_NaHep,
            this.Serum_SST,
            this.Stool_OMR205,
            this.Stool_ME200,
            this.WholeBlood_EDTA,
            this.PAXgene_RNA,
            this.PBMC_CPT_NaCitrate,
            this.Plasma_CPT_NaHep,
            this.PBMC_NaHep
        ];
    }
}

export class SampleByVisit {
    collection_windows: string[] = ["Day0", "Days1to50", "Days51to75", "Days76to90", "Days91to168", "Days169to336", "Unscheduled"]

    BooleanData: boolean[][] = [
        new Array(this.collection_windows.length).fill(false), // 0
        new Array(this.collection_windows.length).fill(false), // 1
        new Array(this.collection_windows.length).fill(false), // 2
        new Array(this.collection_windows.length).fill(false), // 3
        new Array(this.collection_windows.length).fill(false), // 4
        new Array(this.collection_windows.length).fill(false), // 5
        new Array(this.collection_windows.length).fill(false), // 6
        new Array(this.collection_windows.length).fill(false), // 7
        new Array(this.collection_windows.length).fill(false), // 8
        new Array(this.collection_windows.length).fill(false), // 9
    ];

    CountData: number[][] = [
        new Array(this.collection_windows.length).fill(0), // 0
        new Array(this.collection_windows.length).fill(0), // 1
        new Array(this.collection_windows.length).fill(0), // 2
        new Array(this.collection_windows.length).fill(0), // 3
        new Array(this.collection_windows.length).fill(0), // 4
        new Array(this.collection_windows.length).fill(0), // 5
        new Array(this.collection_windows.length).fill(0), // 6
        new Array(this.collection_windows.length).fill(0), // 7
        new Array(this.collection_windows.length).fill(0), // 8
        new Array(this.collection_windows.length).fill(0), // 9
    ];

    constructor() { }
}
